import {
	aR,
	aspectRatios,
	programsApectRatios,
	groupsWithSpecialAspectRatio as groups,
	aspectRatioMapping,
	aspectRatioMappingMobile,
	UPDATED_PREF_VALUES
} from '../global-constants';

export const getPlacement = (aspectRatio) => {
	return aspectRatios.get(aspectRatio);
};

export const getCouponStatus = (aspectRatio) => {
	return (
		aspectRatio === aR.DESKTOP_4X3 ||
		aspectRatio === aR.MOBILE_4X3_COUPON ||
		aspectRatio === aR.MOBILE_4X3_SLIDESHOW ||
		aspectRatio === aR.DESKTOP_9X16 ||
		aspectRatio === aR.MOBILE_9X16
	);
};

export const getProgramAspectRatio = (key) => {
	return programsApectRatios[key];
};

export const isProgramAspectRatioAccount = (accountData) => {
	const { id, topLevelAccount } = accountData;
	let specialAspectRatio;
	groups.every((group) => {
		const { name, members } = group;
		if (
			members.includes(id) ||
			(topLevelAccount &&
				topLevelAccount.some((topAcc) => members.includes(topAcc)))
		) {
			specialAspectRatio = name;
			return false;
		}
		return true;
	});
	return specialAspectRatio;
};

/**
 * Maps the aspect ratio preference based on the device type.
 *
 * @param {string} aspectRatio - The aspect ratio preference to be mapped.
 * @param {boolean} isMobile - Indicates whether the device is mobile or not.
 * @returns {string} The updated aspect ratio preference if applicable.
 *
 * @description
 * - Determines the appropriate aspect ratio mapping based on the device type.
 * - If the aspect ratio is included in `UPDATED_PREF_VALUES`, it updates the aspect ratio
 *   using the corresponding mapping (`aspectRatioMappingMobile` for mobile devices or `aspectRatioMapping` for others).
 * - For tall_vertical_coupon, maps to the standard vertical aspect ratios (Desktop9x16/Mobile9x16).
 */
export const mapAspectRatioPref = (aspectRatio, isMobile) => {
	const mapping = isMobile ? aspectRatioMappingMobile : aspectRatioMapping;
	return UPDATED_PREF_VALUES.includes(aspectRatio)
		? mapping.get(aspectRatio)
		: aspectRatio;
};

export const getCarouselDisplayProps = (
	isCouponCaro,
	isMobile,
	isTallVerticalCoupon,
	containerWidth = 1200
) => {
	if (!isCouponCaro) {
		return { isCouponCaro };
	}

	// For mobile, always show/scroll 1 slide regardless of carousel type
	if (isMobile) {
		return {
			isCouponCaro,
			slidesToScroll: 1
		};
	}

	// For desktop, we need to match Slick's responsive breakpoint logic
	// Use container width to determine slides, matching the responsive breakpoints
	let slidesToScroll;
	if (isTallVerticalCoupon) {
		slidesToScroll = 4;
		// Tall vertical: 4 desktop, 3 at 992px, 2 at 720px
		if (containerWidth >= 992) {
			slidesToScroll = 3;
		} else if (containerWidth >= 764) {
			slidesToScroll = 2;
		}
	} else {
		// 4x3: 3 desktop, 2 at 992px
		slidesToScroll = containerWidth >= 992 ? 3 : 2;
	}

	return {
		isCouponCaro,
		slidesToScroll
	};
};
